import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = {
  children: ReactNode;
  fallback: ReactNode;
};

type State = {
  hasError: boolean;
};

export class MessageRenderBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(_error: Error, _errorInfo: ErrorInfo) {
    // A stale deployment can make Streamdown's lazy syntax-highlighting chunk
    // unavailable. Keep the conversation usable by rendering the plain-text
    // fallback instead of allowing the whole Playground to crash.
  }

  render() {
    return this.state.hasError ? this.props.fallback : this.props.children;
  }
}
